import { Empty } from '@weave/schema-gen-ts/dist/google/protobuf/empty.pb';
import { UseMutateFunction } from 'react-query';
import { useTranslation } from '@frontend/i18n';
import { usePhoneSettingsShallowStore } from '@frontend/phone-config';
import { SecondaryButton, useModalControl } from '@frontend/design-system';
import { trackingId } from '../../tracking';
import { CallGroupDeleteModal } from '../call-group/new/delete-button';

interface DeleteButtonProps {
  id: string;
  name: string;
  type: 'Call Queue' | 'Call Group';
  deleteAction: UseMutateFunction<Empty, unknown, any, unknown>;
}

export const DeleteButton = ({ id, name, type }: DeleteButtonProps) => {
  const { t } = useTranslation('phone');
  const { modalProps, triggerProps } = useModalControl();
  const { settingsTenantLocation } = usePhoneSettingsShallowStore('settingsTenantLocation');
  const tenantId = settingsTenantLocation?.phoneTenantId ?? '';

  return (
    <>
      <SecondaryButton
        size='large'
        destructive
        {...triggerProps}
        css={{ width: 'fit-content' }}
        trackingId={trackingId({ context: 'setting', feature: 'call-groups', details: 'open-delete-modal' })}
      >
        {t(`Delete {{type}}`, { type })}
      </SecondaryButton>
      <CallGroupDeleteModal modalProps={modalProps} name={name} id={id} phoneTenantId={tenantId} />
    </>
  );
};
